const PENDING_OPPORTUNITY_OPEN_KEY = "bb-pending-opportunity-open-id";
const PENDING_OPPORTUNITY_TAB_KEY = "bb-pending-opportunity-open-tab";

export type PendingOpportunityTab =
  | "overview"
  | "pricing"
  | "documents"
  | "revisions"
  | "generated"
  | "todos";

export function setPendingOpportunityOpen(
  opportunityId: string,
  tab?: PendingOpportunityTab,
): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(PENDING_OPPORTUNITY_OPEN_KEY, opportunityId);
    if (tab) window.sessionStorage.setItem(PENDING_OPPORTUNITY_TAB_KEY, tab);
    else window.sessionStorage.removeItem(PENDING_OPPORTUNITY_TAB_KEY);
  } catch {
    // sessionStorage may be unavailable
  }
}

export function consumePendingOpportunityOpen(): {
  id: string;
  tab?: PendingOpportunityTab;
} | null {
  if (typeof window === "undefined") return null;
  try {
    const id = window.sessionStorage.getItem(PENDING_OPPORTUNITY_OPEN_KEY);
    if (!id) return null;
    window.sessionStorage.removeItem(PENDING_OPPORTUNITY_OPEN_KEY);
    const tabRaw = window.sessionStorage.getItem(PENDING_OPPORTUNITY_TAB_KEY);
    window.sessionStorage.removeItem(PENDING_OPPORTUNITY_TAB_KEY);
    const tab =
      tabRaw === "overview" ||
      tabRaw === "pricing" ||
      tabRaw === "documents" ||
      tabRaw === "revisions" ||
      tabRaw === "generated" ||
      tabRaw === "todos"
        ? tabRaw
        : undefined;
    return { id, ...(tab ? { tab } : {}) };
  } catch {
    return null;
  }
}
